import { Dots } from "@/components/carousel/Carousel.types";
import { HoverSwapGallery } from "@/features/pdp/media-gallery/HoverSwapGallery";
import React from "react";
import { PdpCarousel } from "./PdpCarousel";
import { ThumbnailGallery } from "./ThumbnailGallery";
import { ThumbnailCarouselGallery } from "./ThumbnailCarouselGallery";

interface MediaGalleryProps {
  mode: "carousel" | "thumbnail" | "thumbnail-carousel" | "hoverSwap";
  dots?: Dots | "none";
  imageLoading?: "eager" | "lazy";
}

export const MediaGallery = ({
  mode,
  dots,
  imageLoading = "lazy",
}: MediaGalleryProps) => {
  if (mode === "hoverSwap") {
    return <HoverSwapGallery imageLoading={imageLoading} />;
  }

  if (mode === "thumbnail-carousel") {
    return <ThumbnailCarouselGallery />;
  }

  return mode === "carousel" ? (
    <PdpCarousel dots={dots} />
  ) : (
    <ThumbnailGallery />
  );
};
